export const PRIVACY_POLICY = 'https://cycleapp.notion.site/Privacy-Policy-Cycle-07eaa86cc4eb4782a52f9d340dc4b9ce';

export const TERMS_AND_CONDITIONS = 'https://cycleapp.notion.site/Term-and-Conditions-Cycle-506f0f94c05940b79958d9a5b8f2ad97';
